module.exports = [{
      plugin: require('/tmp/13bc7d76/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-XXXXXXXX-X","anonymize":true},
    },{
      plugin: require('/tmp/13bc7d76/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
